import { useCallback, useMemo } from 'react'

import { useUserPermissionsManager } from 'contexts/UserPermissionsManager/Provider'
import { useRouter } from 'next/router'
import { getModuleByPathOnURL } from 'utils/module'

export function useValidatePermissions() {
  const { asPath } = useRouter()

  const { userPermissions } = useUserPermissionsManager()

  const MODULE = useMemo(() => {
    const moduleOnUrl = asPath.split('/')[1]
    return getModuleByPathOnURL(moduleOnUrl)
  }, [asPath])

  const ADMIN_PERMISSION = `IMPACTO-${MODULE?.API_NAME || ''}-ADMIN`

  const validatePermissions = useCallback(
    (permissions?: (string | undefined)[]): boolean => {
      if (!userPermissions) return true
      if (!permissions) return true

      return userPermissions.some((item) => {
        return userPermissions.includes(ADMIN_PERMISSION) || permissions.includes(item)
      }, [])
    },
    [userPermissions]
  )

  return { validatePermissions }
}
